interface GenerationConfigControlsProps {
  options: Record<string, readonly string[]>;
  value: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}

export function GenerationConfigControls({
  options,
  value,
  onChange,
}: GenerationConfigControlsProps) {
  return (
    <div className="flex items-center gap-2">
      {Object.entries(options).map(([key, values]) => {
        const label = key;

        return (
          <div key={key} className="flex items-center gap-1">
            <span className="text-xs opacity-70">{label}</span>
            <select
              value={value[key] ?? values[0]}
              onChange={(e) =>
                onChange({
                  ...value,
                  [key]: e.target.value,
                })
              }
              className="h-6 rounded-md bg-transparent px-1 text-xs outline-none ring-1 ring-inset ring-current/20"
            >
              {values.map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </div>
        );
      })}
    </div>
  );
}
